var _path, _path2, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSinglePayments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 25,
    viewBox: "0 0 17 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.79991 8.3339H1.29991V8.8339V15.1248V15.6248H1.79991H14.8665H15.3665V15.1248V8.8339V8.3339H14.8665H1.79991Z",
    stroke: "#055AEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81384 10.8498C9.67241 10.2864 9.23455 9.88346 8.66462 9.75279V8.98047V8.93047H8.61462H7.87629H7.82629V8.98047V9.75943C7.48618 9.83127 7.20581 9.98816 7.00819 10.2121C6.80252 10.4451 6.68887 10.7482 6.68887 11.0963C6.68887 11.4361 6.79029 11.7297 6.98496 11.9612C7.17934 12.1923 7.46375 12.3581 7.8242 12.4479C7.82423 12.4479 7.82426 12.4479 7.82429 12.4479L8.42937 12.6016L8.42937 12.6016L8.43031 12.6018C8.53307 12.6258 8.60796 12.6676 8.65685 12.7206C8.70513 12.773 8.73091 12.8394 8.73091 12.9192C8.73091 13.0269 8.69128 13.1136 8.62374 13.1738C8.55567 13.2345 8.45527 13.2719 8.3286 13.2719C7.92342 13.2719 7.60713 13.0293 7.53278 12.6747L7.52121 12.6195L7.46781 12.6376L6.6031 12.9304L6.56082 12.9447L6.57028 12.9884C6.71186 13.6414 7.2236 14.1032 7.89281 14.2415V15.013V15.063H7.94281H8.68114H8.73114V15.013V14.2419C9.07744 14.1738 9.36425 14.0207 9.56691 13.7995C9.77789 13.5692 9.89517 13.2677 9.89517 12.9192C9.89517 12.5621 9.79769 12.2578 9.60825 12.0196C9.41891 11.7816 9.14086 11.6137 8.78657 11.5237L8.18194 11.3701C7.95527 11.3058 7.85313 11.1999 7.85313 11.0743C7.85313 10.9576 7.89051 10.8741 7.95597 10.8187C8.02278 10.7622 8.12599 10.729 8.26874 10.729C8.56064 10.729 8.79141 10.9057 8.85201 11.1591L8.86466 11.212L8.91632 11.195L9.78102 10.9095L9.82516 10.8949L9.81384 10.8498Z",
    fill: "#055AEE",
    stroke: "#055AEE",
    strokeWidth: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.49766,
    y: 11.3316,
    width: 4.00091,
    height: 1.24587,
    fill: "#055AEE",
    stroke: "#055AEE",
    strokeWidth: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9996,
    y: 11.3316,
    width: 4.00091,
    height: 1.24587,
    fill: "#055AEE",
    stroke: "#055AEE",
    strokeWidth: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinglePayments);
export default __webpack_public_path__ + "static/media/single-payments.1d646eaf.svg";
export { ForwardRef as ReactComponent };